document.addEventListener('DOMContentLoaded', function () {
  function updateNutritionFacts() {
    const variantJsonElement = document.getElementById('variant-selector-json');

    if(!variantJsonElement) {
      return;
    }

    const variantData = JSON.parse(variantJsonElement.textContent);
    const slug = variantData.title.toLowerCase().trim().replace(/\s+/g, '-');

    const allVariants = document.querySelectorAll('.nutri-facts-variant');
    
    if(allVariants.length == 1){
      allVariants[0].style.display = 'block';
    } else {
      allVariants.values().forEach(it=> {
        it.style.display = it.dataset.variant === slug ? 'block' : 'none';
      })
    }
  }

  document.querySelector('[name="id"]').addEventListener('change', function () {
    updateNutritionFacts();
  });
  updateNutritionFacts();
});